/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import BaseApi, {EventData} from './BaseApi';
import {gettify} from '../util';

export default class ShellApi extends BaseApi {
  public apiEvents: string[] = ['environment', 'imsEnvironment', 'shellInfo'];
  public keyPrefix = 'shell';

  public receive(event: MessageEvent): void {
    let {type, value}: EventData = event.data || {};
    switch (type) {
      case BaseApi.EVENTS.DATA_FULFILL:
        value.shellInfo && gettify(value.shellInfo, 'shellInfo');
        super.receive(event);
        break;
      default:
        super.receive(event);
    }
  }
}
